import {QueryResult} from "@apollo/client";
import {BackendError} from "@common-core/runtime-js/backend";
import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {
  LookupClientEntityData,
  LookupClientEntityVariables
} from "./LookupClientEntity";

export const assertClientEntityPresent = (
  result: QueryResult<LookupClientEntityData, LookupClientEntityVariables>
): ClientEntity => {
  if (!result.data?.entity) {
    throw new BackendError(`Client entity not found`, 404);
  }
  return result.data.entity;
};
